import mavenceryLogoPink from "../../assets/mavenceryLogoPink.png";
import mavenceryLogoWhite from "../../assets/mavenceryLogoWhite.png";
import logo_purple from "../../assets/logo_purple.png";
import { useLocation, useNavigate } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { getStores } from "../../store/actions/Store";
import { useSelector, useDispatch } from "react-redux";

import { setStore } from "../../store/actions/Store/selectedStore";
import { getAllStores } from "../../store/services/Store";
import { getUserProfile } from "store/services/Profile/profile";
import { setProfile } from "store/actions/Profile/profile";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import { storesThemes } from "constants";
import { setGolbalTheme } from "store/actions/Theme/theme";
import HeadTitle from "components/HeadTitle";
import { auth } from "../../firebase";
import { logoutUser } from "store/reducers/Authentication";
export const WelcomePage = () => {
  const { selectedStoreTheme } = useSelector((state) => state.themeColor);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector((store) => store.storeReducer);
  const { user, isAuthenticated } = useSelector((store) => store.userReducer);
  const [selectedStore, setSelectedStore] = useState(null);
  const { storeId } = useParams();
  const [storeTheme, setStoreTheme] = useState(
    selectedStoreTheme && selectedStoreTheme
  );
  const [title, setTitle] = useState("Mavencery");
  const [icon, setIcon] = useState(logo_purple);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAllStores();
        if (result.data) {
          const store = result.data.stores.find(
            (store) =>
              store.id === parseInt(storeId) &&
              store.theme === storesThemes[storeId]
          );
          const themes = storesThemes?.find(
            (storeTheme) => storeTheme?.id === parseInt(store?.id)
          );
          dispatch(getStores(result.data));
          setSelectedStore(result.data.stores[0]);
          if (themes) {
            setStoreTheme(themes);
            setTitle(themes.name);
            setIcon(themes.logo);
            dispatch(setGolbalTheme(themes));
            setSelectedStore({ ...selectedStore, ...storeTheme });
            dispatch(setStore({ ...selectedStore, ...storeTheme }));
          } else {
            //on production store at index zero is selected by default
            setSelectedStore(
              store
                ? store
                : {
                    ...result.data.stores[0],
                    isWhiteLabel: false,
                    cover: result?.data.stores[0].logo,
                  }
            );
          }
        }
        if (user) {
          const profile = await getUserProfile(user.accessToken, user.data.id);
          if (profile.success) {
            dispatch(setProfile(profile.data));
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user, selectedStoreTheme, storeId, storeTheme]);
  const isWelcomePage = ["/mav", `/${selectedStore?.id}`, "/"].includes(
    location.pathname
  );
  useEffect(() => {
    const handleLogout = async () => {
      if (isWelcomePage) {
        localStorage.removeItem("userState");
        localStorage.removeItem("storeState");
        await auth.signOut();
        dispatch(logoutUser());
      }
    };
    handleLogout();
  }, [dispatch, isWelcomePage, location]);

  const handleStoreSelect = (selectedStore) => {
    dispatch(setStore({ ...selectedStore, ...storeTheme }));
    if (isAuthenticated) {
      navigate(`/stores/${selectedStore?.id}/dashboard`);
    } else {
      navigate(`/stores/${selectedStore?.id}/items`);
    }
  };
  const handleLogin = (selectedStore) => {
    console.log("login!!");
    setSelectedStore(setStore({ ...selectedStore, ...storeTheme }));
    dispatch(setStore({ ...selectedStore, ...storeTheme }));
    navigate(`/auth?type=login`);
  };
  const handleSignUp = (selectedStore) => {
    setSelectedStore(setStore({ ...selectedStore, ...storeTheme }));
    dispatch(setStore({ ...selectedStore, ...storeTheme }));
    navigate(`/auth?type=signup`);
  };
  if (!data || data.length === 0 || !data.stores) {
    return <Loader />;
  }

  return (
    <div
      className={`flex flex-col h-screen text-white md:flex-col extraMedium:flex-col lg:flex-row`}
    >
      <div
        style={{
          backgroundColor: storeTheme?.theme.backgroundColor,
        }}
        className={`w-full   h-2/4 md:w-full lg:h-full extraMedium:w-full   lg:w-2/4`}
      >
        {selectedStore?.isWhiteLabel === true ? (
          <div className="flex flex-col items-center justify-center h-full ">
            <img
              className="inline mt-2 ml-2 mr-2 lg:max-w-xl h-96 "
              src={selectedStore?.whiteLogo}
              alt="mavencery logo"
            />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full ">
            <div className="m-8 mt-0 text-2xl font-bold text-center lg:text-4xl md:text-3xl ">
              Want to explore how
              <img
                className="inline w-40 h-auto mt-2 ml-2 mr-2 md:w-44"
                src={mavenceryLogoWhite}
                alt="mavencery logo"
              />
              works?
            </div>
            <div className="items-center ml-6 mr-6 text-xs text-center md:text-xl">
              You will need an account to save, share, or edit your shopping
              lists
            </div>
          </div>
        )}
      </div>
      <div className="w-full bg-white rounded-tl-3xl rounded-tr-3xl h-2/4 md:w-full lg:h-full extraMedium:w-full lg:w-2/4 lg:rounded-none ">
        <div className="flex flex-col items-center justify-start h-full mt-2 text-white md:mt-20 lg:justify-center lg:mt-0">
          <div className="hidden lg:block">
            {selectedStore?.isWhiteLabel === true ? (
              <p
                style={{ color: selectedStore?.theme.color }}
                className="hidden mx-4 mb-3 text-5xl font-extrabold text-black"
              >
                {selectedStore?.name}
              </p>
            ) : (
              <img
                className="inline w-40 h-auto mt-2 mb-4 ml-2 mr-2 md:w-72"
                src={mavenceryLogoPink}
                alt="mavencery logo"
              />
            )}
          </div>

          <div
            className={`flex flex-col items-center justify-center extraMedium:h-1/2 lg:w-2/4 lg:h-1/2 lg:bg-gray-100 lg:rounded-3xl md:w-2/4 ${
              selectedStore?.isWhiteLabel === true ? "pt-16" : ""
            }`}
          >
            {selectedStore?.isWhiteLabel === false && (
              <button
                style={{
                  backgroundColor: storeTheme?.theme.backgroundColor,
                }}
                onClick={() => handleStoreSelect(selectedStore)}
                className="p-1 mt-16 mb-6 font-bold text-white rounded-lg hover:bg-lighterPurple lg:mt-8 w-80 lg:w-4/5 "
              >
                Explore
              </button>
            )}
            <button
              onClick={() => handleLogin(selectedStore)}
              style={{
                backgroundColor: storeTheme?.theme.backgroundColor,
              }}
              className="p-1 mb-6 font-bold text-white rounded-lg w-80 lg:w-4/5 hover:bg-lighterPurple "
            >
              {`${selectedStore?.isWhiteLabel === true ? "Order" : "Login"}`}
            </button>
            <button
              onClick={() => handleSignUp(selectedStore)}
              style={{
                backgroundColor: storeTheme?.theme.backgroundColor,
              }}
              className="p-1 mb-6 font-bold text-white rounded-lg w-80 lg:w-4/5 hover:bg-lighterPurple "
            >
              Create Account
            </button>

            <div className="items-center mt-2 ml-4 mr-4 text-sm text-center text-black lg:text-xs md:text-xl">
              By signing up you accept all the terms and conditions.
            </div>
          </div>
        </div>
      </div>
      <HeadTitle title={title} icon={icon} />
    </div>
  );
};
